var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.data,"disable-pagination":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('code',[_vm._v(_vm._s(item.name))])]}},{key:"item.description",fn:function(ref){
var item = ref.item;
return [(item.description)?_c('markdown',{attrs:{"source":item.description}}):_vm._e()]}},{key:"item.props",fn:function(ref){
var item = ref.item;
return [(item.props.length)?_c('params-table',{attrs:{"data":item.props}}):_c('div',[_vm._v(" No props ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }